module.exports = __webpack_public_path__ + "static/Pharmacology-1c973ac89d3d1bbed6c2e700cd1e691d.png";